export const getSubscribe = (state) => state.subscribe;
export const getEmail = (state) => state.subscribe.email;
